import { UserManager } from 'oidc-client-ts';
import { reportErrorToDatadog } from '../../logging/datadog';
import { isNotIframe } from '../../utils';
import { config } from '../config';
import { getSigninOptions } from '../login/environmentUtils';
import { routeStorage } from '../login/storage';
import { trace } from './trace';

export const attemptInitialSignIn = async (userManager: UserManager) => {
    const isFreshRedirect = Boolean(param(window, /access_token=([^&]+)/u));
    try {
        const user = await userManager.signinSilent();
        return Promise.resolve(user);
    } catch (error) {
        trace('oidc.signinSilent failed, trying page redirect...', error);

        if (config.login.preventRedirect) {
            trace('[feature/login] redirect prevented due to config. Error was', error);
        } else if (isFreshRedirect) {
            trace('oidc.signinSilent.error', 'redirect prevented due to suspicious signing error', error);
            reportErrorToDatadog(
                'could not perform signinSilent. Session expired or third-party cookies are not enabled (incognito mode).',
                { error },
            );
            routeStorage.discardRoute();
        } else {
            if (shouldStoreRoute()) {
                saveCurrentRoute();
            }
            await userManager.signinRedirect(getSigninOptions(config.environmentFromUri));
        }

        trace('auth problem?', error);
        throw new Error('Need to sign in');
    }
};

const saveCurrentRoute = () => {
    const initialRoute = [window.location.hash, window.location.search].join('').replace(/^#\/?/u, '');
    routeStorage.saveRoute(initialRoute);
    trace('saving initial route', initialRoute);
};

const param = (window: Window, regex: RegExp, defaultValue = null) => {
    const match = regex.exec(decodeURI(window.location.href));
    return match ? match[1] : defaultValue;
};

const hasNotRedirectUriInPath = () => {
    const redirectUri = config.login.redirectUri;
    const path = window.location.href;
    return redirectUri && !path.startsWith(redirectUri);
};

const hasNotSilentRedirectUriInPath = () => {
    const silentRedirectUri = config.login.silentRedirectUri;
    const path = window.location.href;
    return silentRedirectUri && !path.startsWith(silentRedirectUri);
};

const shouldStoreRoute = () => {
    return isNotIframe() && hasNotRedirectUriInPath() && hasNotSilentRedirectUriInPath();
};
